import { render } from "./SideBar.vue?vue&type=template&id=3e9b697c"
import script from "./SideBar.vue?vue&type=script&lang=js"
export * from "./SideBar.vue?vue&type=script&lang=js"

import "./SideBar.vue?vue&type=style&index=0&id=3e9b697c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__